module.exports = __webpack_public_path__ + "static/img/gift_new.db9eed2.gif";